import { render, staticRenderFns } from "./PurchaseEntryTable.vue?vue&type=template&id=8f5e1524&scoped=true"
import script from "./PurchaseEntryTable.vue?vue&type=script&lang=js"
export * from "./PurchaseEntryTable.vue?vue&type=script&lang=js"
import style0 from "./PurchaseEntryTable.vue?vue&type=style&index=0&id=8f5e1524&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f5e1524",
  null
  
)

export default component.exports